import ReqError from "@source/api/reqError";
import { api } from "@source/api/http";
import {
  IResetPasswordRequest,
  IChangeEmailRequest,
  IResetPasswordResponse,
  IChangeEmailResponse,
  IConfirmAddRequestResponse
} from "../models/familyMemberModels";

export default class FamilyMemberService {
  static async resetPassword(body: IResetPasswordRequest) {
    try {
      return(await api.post<IResetPasswordResponse>("auth/family-member/forgot-password/reset", body)).data;
    } catch (e: any) {
      const downError = ReqError.handleServerDownError(e);
      if(downError) {
        throw downError;
      }
      throw ReqError.resetFamilyMemberPasswordError(e.response)
    }
  }

  static async changeEmail(body: IChangeEmailRequest, familyMemberId: string) {
    try {
      return(await api.post<IChangeEmailResponse>(`auth/family-member/${familyMemberId}/change-email`, body)).data;
    } catch (e: any) {
      const downError = ReqError.handleServerDownError(e);
      if(downError) {
        throw downError;
      }
      throw ReqError.changeFamilyMemberEmailError(e.response)
    }
  }

  static async confirmAddRequest(data) {
    try {
      return(await api.get<IConfirmAddRequestResponse>(`family-member/add-requests/${data.id}/confirm`, {
        params: data
      })).data;
    } catch (e: any) {
      const downError = ReqError.handleServerDownError(e);
      if(downError) {
        throw downError;
      }
      throw ReqError.changeFamilyMemberEmailError(e.response)
    }
  }
}